import { render, staticRenderFns } from "./HotelCard.vue?vue&type=template&id=589f317a&scoped=true"
import script from "./HotelCard.vue?vue&type=script&lang=js"
export * from "./HotelCard.vue?vue&type=script&lang=js"
import style0 from "./HotelCard.vue?vue&type=style&index=0&id=589f317a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589f317a",
  null
  
)

export default component.exports